import {
  OfferDiscountType,
  OfferState,
} from "../constants/offers.constants";

export const computeOfferState = (
  enabled: boolean,
  startDate?: string,
  endDate?: string,
  now: Date = new Date()
): OfferState => {
  if (!enabled) {
    return OfferState.Disabled;
  }
  if (endDate) {
    const end = new Date(endDate);
    if (end < now) {
      return OfferState.Expired;
    }
  }
  if (startDate) {
    const start = new Date(startDate);
    if (start > now) {
      return OfferState.Scheduled;
    }
  }
  return OfferState.Active;
};

export const isOfferScheduled = (startDate?: string, endDate?: string): boolean =>
  Boolean(startDate && endDate);

export const formatDateForApi = (date?: string): string | undefined => {
  if (!date) return undefined;
  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return undefined;
  return parsed.toISOString().replace("T", " ").split(".")[0];
};

export const setStartOfDay = (date: Date): Date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);

export const setEndOfDay = (date: Date): Date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
